import axios from '../../helpers/axiosRequests';
import { mapArrayToObj } from '../../helpers/utils';
const { VUE_APP_SERVER_BASE_URL: BASE_URL } = process.env;

const INITIAL_STATE = {
  isSubmitting: false,
  isLoading: false,
  errors: {},
  companyAgents: {},
};

const actions = {
  saveAgent: ({ commit, rootState }, data) => {
    const { currentUser } = rootState.auth;
    commit('SAVING_AGENT');
    return axios
      .post(`${BASE_URL}/companies/${currentUser.companyId}/users`, data)
      .then((res) => {
        const { data } = res.data;
        commit('SAVING_AGENT_COMPLETE', data);
        return data;
      })
      .catch((err) => {
        commit('SAVING_AGENT_FAILED', err);
        throw err;
      });
  },
  getCompanyAgents: ({ commit, rootState }) => {
    const { currentUser } = rootState.auth;
    commit('FETCHING_DATA');
    return axios
      .get(`${BASE_URL}/companies/${currentUser.companyId}/users`)
      .then((res) => {
        const { rows } = res.data;
        const results = mapArrayToObj(rows);
        commit('FETCHING_COMPANY_AGENTS_COMPLETE', results);
        return results;
      })
      .catch((err) => {
        throw err;
      });
  },
};
const mutations = {
  SAVING_AGENT(state) {
    state.isSubmitting = true;
  },
  SAVING_AGENT_COMPLETE(state, data) {
    state.isSubmitting = false;
    state.companyAgents = { [data.id]: data, ...state.companyAgents };
  },
  SAVING_AGENT_FAILED(state, errors) {
    state.isSubmitting = false;
    state.errors = errors;
  },
  FETCHING_DATA(state) {
    state.isLoading = true;
  },
  FETCHING_COMPANY_AGENTS_COMPLETE(state, data) {
    state.isLoading = false;
    state.companyAgents = { ...state.companyAgents, ...data };
  },
  FETCHING_DATA_FAILED(state) {
    state.isLoading = false;
  },
};
const getters = {
  isSubmitting: (state) => state.isSubmitting,
  companyUsers: (state) => state.companyAgents,
};

export const agent = {
  namespaced: true,
  actions,
  mutations,
  getters,
  state: INITIAL_STATE,
};
